import { Component, inject } from '@angular/core';

import { CommonMessages, MenuActionOrigin, MenuDisplayMode } from '@frontend/vanilla/core';
import { MenuItemComponent } from '@frontend/vanilla/features/menus';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    imports: [MenuItemComponent],
    selector: 'vn-am-logout',
    templateUrl: 'logout.html',
})
export class LogoutComponent extends AccountMenuItemBase {
    msg: any;
    wait: boolean;

    constructor() {
        const commonMessages = inject(CommonMessages);

        super();

        this.msg = commonMessages;
    }

    logout() {
        if (this.wait) {
            return;
        }

        this.wait = true;

        this.menuActionsService
            .invoke('logout', MenuActionOrigin.Menu, [undefined, undefined, { manualLogout: 'true' }])
            .then(() => (this.wait = false));
    }

    protected readonly MenuDisplayMode = MenuDisplayMode;
}
